// File for logic corresponding to AffiliatesListing component
import { Component } from 'js-component-framework';
import Swiper, { Grid, Navigation, Pagination } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/grid';
import 'swiper/scss/pagination';

/**
 * Component for Affiliates Listing
 */
export default class AffiliatesListing extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Initialize.
    this.init();
  }

  /**
   * Initialize the Swiper component.
   */
  init() {
    if (!this.children.affiliatesSwiper || this.children.affiliatesSwiper.length === 0) {
      return;
    }

    this.affiliatesSwiper = new Swiper(this.children.affiliatesSwiper, {
      breakpoints: {
        1200: {
          slidesPerGroup: 3,
          slidesPerView: 3,
        },
        768: {
          slidesPerGroup: 2,
          slidesPerView: 2,
        },
      },
      keyboard: {
        enabled: true,
      },
      modules: [Grid, Navigation, Pagination],
      navigation: {
        enabled: false,
      },
      pagination: {
        clickable: true,
        el: this.children.affiliatesPagination,
        renderBullet: (index, className) => `<span class="${className}">${(index + 1)}</span>`,
      },
      scrollbar: {
        enabled: false,
      },
      slidesPerView: 1,
      spaceBetween: 42,
    });
  }
}
